<template>
  <div class="settings-wrp" :key="route.path">
    <div class="settings-title">
      {{ t('Subscription') }}
    </div>
    <div class="settings-content settings-columns-wrp">
      <div class="settings-column">
        <details-subscription />
        <details-subscription-limits />
      </div>
      <div class="settings-column">
        <payment-method />
        <invoices :data-invoices="dataInvoices" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  getBillingCustomerApiRequest,
  getBillingInvoicesApiRequest,
  getBillingSubscriptionApiRequest,
} from '@/services/api/billing-api';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import DetailsSubscription from './forms/details-subscription.vue';
import PaymentMethod from './forms/payment-method.vue';
import Invoices from './forms/invoices.vue';
import DetailsSubscriptionLimits from '@/views/settings/subscription/forms/details-subscription-limits/details-subscription-limits.vue';
import { useI18n } from '@/composables';
import { useStore } from '@/store';

const route = useRoute();
const { t } = useI18n();
const store = useStore();

const dataInvoices = ref<unknown>(null);

onMounted(() => {
  store.setLoading(true);
  Promise.all([
    getBillingSubscriptionApiRequest(),
    getBillingCustomerApiRequest(),
    getBillingInvoicesApiRequest(),
  ])
    .then(([subscription, customer, invoices]) => {
      store.setBilling(subscription);
      store.setBillingCustomer(customer);
      dataInvoices.value = invoices;
    })
    .finally(() => {
      store.setLoading(false);
    });
});
</script>

<style lang="scss" scoped></style>
